<template>
  <div class="pay_list">
    <div class="pay_list__panel">
      <h3>{{ $t("message.shop.payList.payType") }}</h3>
      <div class="pay_list__total_money">
        <span>{{ $t("message.shop.payList.total") }}</span>
        <span class="money">{{payAmountMoney.symbol}}{{$currencyFormatter(payAmountMoney.number)}}</span>
      </div>
      <div class="pay_list__list">
        <div v-if="!en" class="pay_list__item global_pointer" @click="$emit('choosePayType', 4)">
          <img src="@/assets/imgs/login/unionpay.png" alt="">
          <div>{{ $t("message.shop.payList.unionPay") }}</div>
        </div>
        <div v-if="!en && !isWx" class="pay_list__item global_pointer" @click="$emit('choosePayType', 1)">
          <img src="@/assets/imgs/login/ZFB.png" alt="">
          <div>{{ $t("message.shop.payList.aliPay") }}</div>
        </div>
        <div v-if="!en && isWx" class="pay_list__item global_pointer" @click="$emit('choosePayType', 2)">
          <img src="@/assets/imgs/login/weixin.png" alt="">
          <div>{{ $t("message.shop.payList.weixinPay") }}</div>
        </div>
        <div v-if="en" class="pay_list__item global_pointer" @click="$emit('choosePayType', 3)">
          <img src="@/assets/imgs/login/bankcard.png" alt="">
          Credit Card
        </div>
      </div>
      <img class="pay_list__close" src="@/assets/imgs/close.png" alt="close" @click="$emit('close')">
    </div>
  </div>
</template>
<script>
import { getDevicedId, plateForm } from '@/utils';
const isWx = plateForm().os === 'wxClient';
export default {
  props: {
    payAmountMoney: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data(){
    return {
      en: this.$i18n.locale === 'en',
      isWx
    }
  },
  methods:{
  }
}
</script>
<style lang="less">
.pay_list {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.5);
  &__panel {
    position: absolute;
    width: 100%;
    background: #ffffff;
    left: 0;
    bottom: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    overflow: hidden;
    padding: 50px 32px 0;
    box-sizing: border-box;
    & h3{
      height: 40px;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bold;
      color: #231F20;
      line-height: 40px;
      margin: 0;
      padding: 0;
      text-align: left;
      margin-bottom: 24px;
    }
  }
  &__total_money{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
    & .money{
      height: 20px;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bold;
      color: #345547;
      line-height: 20px;
    }
  }
  &__item{
    height: 46px;
    line-height: 46px;
    background: #F2F2F2;
    border-radius: 23px;
    position: relative;
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    margin-bottom: 20px;
    padding-left: 45px;
    & div{
      margin-left: 40px;
    }
    & img{
      position: absolute;
      width: 30px;
      height: 30px;
      left: 8px;
      top: 8px;
    }
  }
  &__close{
    width: 26px;
    height: 26px;
    position: absolute;
    right: 12px;
    top: 12px;
  }
}
</style>